import pushNotification from '@apis/pushNotification'
import Button from '@components/button'
import Fields from '@components/fields'
import Row from '@components/row'
import Wrapper from '@components/wrapper'
import theme from '@utils/theme'
import { Form, Formik } from 'formik'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from '@emotion/styled'
import { FieldGroup, FormRow, outlineButton, UploadWrapper } from './style'

const PushNotificationForm = () => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [initialValues, setInitialValues] = useState({
    title: '',
    body: '',
    image: '',
  })

  useEffect(() => {
    setInitialValues({
      title: state?.title || '',
      body: state?.description || '',
      image: state?.image || '',
    })
  }, [state])

  const handleSubmit = async (values: any, { resetForm }: any) => {
    try {
      const imagePayload = values.image?.base64
        ? {
            base64: values.image.base64,
            extension: values.image.extension,
          }
        : state?.image || null

      const payload = {
        title: values.title,
        body: values.body,
        ...(imagePayload && { image: imagePayload }),
      }

      if (state?.id) {
        await pushNotification.update({
          state: 'pushNotification',
          data: JSON.stringify(payload),
          id: state.id,
        })
      } else {
        await pushNotification.create({
          state: 'pushNotification',
          data: JSON.stringify(payload),
        })
      }

      resetForm()
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Wrapper>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {() => (
          <Form>
            <FormRow>
              <FieldGroup>
                <Fields.Input
                  name="title"
                  label="Title"
                  placeholder="Type here"
                  styleInput="width:100%"
                />
                <Fields.TextArea
                  name="body"
                  label="Description"
                  placeholder="Type here"
                  styleInput="max-width:100%;height:24vh;resize:none;"
                />
              </FieldGroup>

              <UploadWrapper>
                <Fields.Upload name="image" variant="banner" />
              </UploadWrapper>
            </FormRow>

            <div
              style={{
                justifyContent: 'flex-end',
                marginTop: '20px',
                gap: '12px',
                flexWrap: 'wrap',
                display: 'flex',
              }}
            >
              <Button
                type="reset"
                title="Reset"
                height={45}
                width={100}
                styleButton={outlineButton}
              />

              {state && (
                <Button
                  title="Cancel"
                  height={45}
                  width={100}
                  onClick={() => navigate(-1)}
                  styleButton={`
                    background-color: #dc3545;
                    color: white;
                    border: none;
                  `}
                />
              )}

              <Button
                title={state ? 'Update' : 'Submit'}
                height={45}
                width={100}
                type="submit"
              />
            </div>
          </Form>
        )}
      </Formik>
    </Wrapper>
  )
}

export default PushNotificationForm
